import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { CommandAsync, ICommand } from "@nahuelmorata/ngx-command";
import { Store } from "@ngxs/store";
import { filter, map, mergeMap, take } from "rxjs/operators";
import { CategoriaFiltroDTO, TagDTO } from "@DTOS";
import { ModalService } from "@shared/services";
import { EtiquetasAcciones, State } from "@shared/states";
import { Condicion } from "../../clases/Condicion";
import { UntypedFormControl } from "@angular/forms";
import { firstValueFrom, Subscription } from "rxjs";

@Component({
    selector: "app-condicion-si-tiene-tag",
    templateUrl: "./condicion-si-tiene-tag.component.html",
    styleUrls: ["./condicion-si-tiene-tag.component.scss"]
})
export class CondicionSiTieneTagComponent implements OnInit, OnDestroy {
    @Input() public condicion: Condicion;

    public categorias: CategoriaFiltroDTO[] = [];
    public etiquetas: TagDTO[] = [];
    public categoriaSeleccionadaControl = new UntypedFormControl(null);
    public etiquetaSeleccionadaControl = new UntypedFormControl(null);

    public borrarOperandoCmd: ICommand = new CommandAsync(() => this.borrar());

    private subs = new Subscription();

    constructor(private store: Store, private modalService: ModalService) { }

    ngOnInit(): void {
        this.subs.add(
            this.categoriaSeleccionadaControl.valueChanges.pipe(
                mergeMap(() => this.cargarEtiquetas(this.categoriaSeleccionadaControl.value))
            ).subscribe()
        );
        this.subs.add(
            this.etiquetaSeleccionadaControl.valueChanges.subscribe(() => {
                this.condicion.data = `t${this.etiquetaSeleccionadaControl.value.id}`;
            })
        );
        this.cargarDatos();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private async cargarDatos() {
        this.store.dispatch(new EtiquetasAcciones.ObtenerTodo());
        this.categorias = await firstValueFrom(
            this.store.select((state: State) => state.etiquetas.categorias).pipe(
                filter(categorias => categorias.length !== 0),
                take(1)
            )
        );
    }

    private async cargarEtiquetas(categoria: CategoriaFiltroDTO) {
        this.etiquetas = await firstValueFrom(
            this.store.select((state: State) => state.etiquetas.etiquetas).pipe(
                filter(etiquetas => etiquetas.length !== 0),
                take(1),
                map(etiquetas => etiquetas.filter(etiqueta => etiqueta.tipo.id === categoria.id))
            )
        );
    }

    private async borrar() {
        const seguroBorrar = await this.modalService.openModalDecision(
            "Esta seguro que quiere eliminar el operando?", { centered: true }
        );

        if (!seguroBorrar) {
            return;
        }

        this.condicion.borrar();
    }
}
